<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="$emit('close')">
            {{ $t('com.file.failed-people-group-remove.title') }}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <section class="d-flex flex-column gap-2">
                <section class="alert alert-danger d-flex flex-row">
                    <font-awesome-icon icon="fa-solid fa-trash" /> 
                    <section>
                        <span>{{ $t('com.file.failed-people-group-remove.cannot-remove-people-from-group') }}</span>
                        <ul>
                            <li v-for="(item, index) in peopleFailed" :key="index">{{ item.first_name }} {{ item.last_name }}</li>
                        </ul>
                    </section>
                </section>
                <span>{{ $t('com.file.failed-people-group-remove.do-you-want-to-continue-without-these-people') }}</span>
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="$emit('close')">
                {{$t('com.global.no')}}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave v-if="peopleWithoutError.length > 0" @click="$emit('groupMemberRemove', peopleWithoutError)">
                {{$t('com.global.yes')}}
            </eSesjaModalButtonSave>
            <eSesjaModalButtonSave v-else :disabled="true" v-tooltip="$t('com.file.failed-people-group-remove.no-people-without-error')">
                {{$t('com.global.yes')}}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
export default {
    name: "FailedPeopleGroupRemove",
    emits: ["groupMemberRemove", "close"],
    props: {
        peopleFailed: {
            type: Array,
            required: true,
            default: () => []  
        },
        selectedPeople: {
            type: Array,
            required: true,
            default: () => []  
        }
    },
    components: {
    },
    computed: {
        peopleWithoutError(){
            return this.selectedPeople.filter(item => !this.peopleFailed.some(el => el.id === item));
        }
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>